export default __webpack_public_path__ + "static/media/mazda.d102cc73.svg";